export const AddEmployee = 'Add Employees';
export const AddProjects = 'Add Project';
export const Cancel = 'Cancel';
export const Submit = 'Submit';
export const SearchProject = 'Search Project';
export const NO_PROJECTS = 'No Projects..';
export const NO_LEAVE_REQUESTS = 'No leave requests';
export const NO_WFH_REQUESTS = 'No WFH requests';
export const EmployeeRole = {
  NONE: 'NONE',
  LEAD: 'LEAD',
  SHADOW: 'SHADOW',
  UI_DEV: 'UI DEVELOPER',
  BACKEND_DEV: 'BACKEND ',
};
